import React from "react";
import "./../../Assets/CSS/privacy.css";

const PrivacyPolicy = () => {
  return (
    <section className="privacy g-other-pages">
       <title>Privacy & Term of Service | ScriptSite RX</title>
      <div className="container">
        <h2>Privacy Policy</h2>

        <p>
          Protecting your private information is our priority. This Statement of
          Privacy applies to www.scriptsiterx.com and ScriptSite Pharmacy
          Partners, LLC (“ScriptSite” or the “Company”) and governs data
          collection and usage. For the purposes of this Privacy Policy, unless
          otherwise noted, all references to ScriptSite Pharmacy Partners, LLC
          include www.scriptsiterx.com (“Site”) and ScriptSite. The ScriptSite
          website is a specialized pharmacy specifically designed for behavioral
          health, HIV/AIDS, long-term care and addiction care. Our mission is to
          help patients, prescribers, nurses, and case managers diagnose, treat,
          and recover-better.
        </p>

        <p>
          By using the ScriptSite website, you consent to the data practices
          described in this statement.
        </p>

        <div className="g-maring-top"></div>

        <h5>Collection of your Personal Information</h5>
        <p>
          ScriptSite may collect personal information, including but not limited
          data such as your:
        </p>
        {/* <ul>
          <li>First and last Name</li>
          <li>Mailing address</li>
          <li>Telephone number</li>
          <li>Email address</li>
        </ul> */}
        <ul
          style={{
            marginLeft: "25px",
            marginTop: "15px",
            padding: 0,
            listStyleType: "circle",
            color: "#444",
            lineHeight: "1.8",
            fontSize: "16px",
          }}
        >
          <li style={{ marginBottom: "10px" }}>First and last Name</li>
          <li style={{ marginBottom: "10px" }}>Mailing address</li>
          <li style={{ marginBottom: "10px" }}>Telephone number</li>
          <li style={{ marginBottom: "10px" }}>Email address</li>
        </ul>

        <p>
          We do not collect any personal information about you unless you
          voluntarily provide it to us. However, you may be required to provide
          certain personal information to us when you elect to use certain
          products or services available on the Site. These may include: (a)
          registering for an account on our Site; (b) entering a promotion
          sponsored by us or one of our partners; (c) signing up for special
          offers from selected third parties; (d) sending us an email message;
          (e) submitting your credit card or other payment information when
          ordering and purchasing products and services on our Site. To wit, we
          will use your information for, but not limited to, communicating with
          you in relation to services and/or products you have requested from
          us. We also may gather additional personal or non-personal information
          in the future.
        </p>

        <div className="g-maring-top"></div>

        <h5>Sharing Information with Third Parties</h5>
        <p>
          ScriptSite does not sell, rent or lease its customer lists to third
          parties but reserves the right to do at a future time.{" "}
        </p>
        <p>
          ScriptSite may, from time to time, contact you on behalf of external
          business partners about a particular offering that may be of interest
          to you. In those cases, your unique personally identifiable
          information (e-mail, name, address, telephone number) is not
          transferred to the third party. ScriptSite may share data with trusted
          partners to help perform statistical analysis, send you email or
          postal mail, provide customer support, or arrange for deliveries. All
          such third parties are prohibited from using your personal information
          except to provide these services to ScriptSite, and they are required
          to maintain the confidentiality of your information.{" "}
        </p>
        <p>
          ScriptSite may disclose your personal information, without notice, if
          required to do so by law or in the good faith belief that such action
          is necessary to: (a) conform to the edicts of the law or comply with
          legal process served on ScriptSite or the Site; (b) protect and defend
          the rights or property of ScriptSite; and/or (c) act under exigent
          circumstances to protect the personal safety of users of ScriptSite,
          or the public.{" "}
        </p>
        <div className="g-maring-top"></div>

        <h5>Tracking User Behavior</h5>
        <p>
          ScriptSite may keep track of the websites and pages our users visit
          within ScriptSite, in order to determine what ScriptSite services are
          the most popular. This data is used to deliver customized content and
          advertising within ScriptSite to customers whose behavior indicates
          that they are interested in a particular subject area.{" "}
        </p>
        <div className="g-maring-top"></div>

        <h5>Automatically Collected Information</h5>
        <p>
          Information about your computer hardware and software may be
          automatically collected by ScriptSite. This information can include:
          your IP address, browser type, domain names, access times and
          referring website addresses. This information is used for the
          operation of the service, to maintain quality of the service, and to
          provide general statistics regarding use of the ScriptSite website.{" "}
        </p>

        <div className="g-maring-top"></div>

        <h5>Use of Cookies</h5>
        <p>
          The ScriptSite website may use “cookies” to help you personalize your
          online experience. A cookie is a text file that is placed on your hard
          disk by a web page server. Cookies cannot be used to run programs or
          deliver viruses to your computer. Cookies are uniquely assigned to
          you, and can only be read by a web server in the domain that issued
          the cookie to you.{" "}
        </p>
        <p>
          One of the primary purposes of cookies is to provide a convenience
          feature to save you time. The purpose of a cookie is to tell the Web
          server that you have returned to a specific web page. For example, if
          you personalize ScriptSite web pages, or register with ScriptSite site
          or services, a cookie helps ScriptSite to recall your specific
          information on subsequent visits. This simplifies the process of
          recording your personal information, such as billing addresses,
          shipping addresses, and so on. When you return to the same ScriptSite
          website, the information you previously provided can be retrieved, so
          you can easily use the ScriptSite features that you customized.{" "}
        </p>
        <p>
          You have the ability to accept or decline cookies. Most Web browsers
          automatically accept cookies, but you can usually modify your browser
          setting to decline cookies if you prefer. If you choose to decline
          cookies, you may not be able to fully experience the interactive
          features of the ScriptSite services or websites you visit.{" "}
        </p>

        <div className="g-maring-top"></div>
        <h5>Links</h5>
        <p>
          This website may contain links to other sites. Please be aware that we
          are not responsible for the content or privacy practices of such other
          sites. We encourage our users to be aware when they leave our site and
          to read the privacy statements of any other site that collects
          personally identifiable information.{" "}
        </p>

        <h5>Security of your Personal Information</h5>
        <p>
          ScriptSite secures your personal information from unauthorized access,
          use, or disclosure. ScriptSite uses the following methods for this
          purpose:{" "}
        </p>

        <ul
          style={{
            marginLeft: "25px",
            marginTop: "15px",
            padding: 0,
            listStyleType: "circle",
            color: "#444",
            lineHeight: "1.8",
            fontSize: "16px",
          }}
        >
          <li style={{ marginBottom: "10px" }}>SSL Protocol</li>
        </ul>

        <p>
          When personal information (such as a credit card number) is
          transmitted to other websites, it is protected through the use of
          encryption, such as the Secure Sockets Layer (SSL) protocol.{" "}
        </p>
        <p>
          We strive to take appropriate security measures to protect against
          unauthorized access to or alteration of your personal information.
          Unfortunately, no data transmission over the Internet or any wireless
          network can be guaranteed to be 100% secure. As a result, while we
          strive to protect your personal information, you acknowledge that: (a)
          there are security and privacy limitations inherent to the Internet
          which are beyond our control; and (b) security, integrity, and privacy
          of any and all information and data exchanged between you and us
          through this Site cannot be guaranteed.{" "}
        </p>
        <div className="g-maring-top"></div>

        <h5>Children Under Thirteen</h5>
        <p>
          ScriptSite does not knowingly collect personally identifiable
          information from children under the age of thirteen. If you are under
          the age of thirteen, you must ask your parent or guardian for
          permission to use this website.{" "}
        </p>

        <div className="g-maring-top"></div>
        <h5>E-mail Communications</h5>
        <p>
          From time to time, ScriptSite may contact you via email for the
          purpose of providing announcements, promotional offers, alerts,
          confirmations, surveys, and/or other general communication.{" "}
        </p>

        <div className="g-maring-top"></div>
        <h5>External Data Storage Sites</h5>
        <p>
          We may store your data on servers provided by third party hosting
          vendors with whom we have contracted.{" "}
        </p>

        <div className="g-maring-top"></div>
        <h5>Designated Countries Privacy Rights</h5>
        <p>
          This Section only applies to Users and Customers of the Services that
          are located in the European Economic Area, United Kingdom and/or
          Switzerland (collectively, the “Designated Countries”) at the time of
          data collection. We may ask you to identify which country you are
          located in when you use some of the Services, or we may rely on your
          IP address to identify which country you are located in. Where we rely
          only on your IP address, we cannot apply the terms of this Section to
          any User or Customer that masks or otherwise obfuscates their location
          information so as not to appear located in the Designated Countries.
          If any terms in this Section conflict with other terms contained in
          this Policy, the terms in this Section shall apply to Users and
          Customers in the Designated Countries.
        </p>
        <p>
          ScriptSite is a data controller with regard to any personal
          information collected from Customers or Users of its Services. A “data
          controller” is an entity that determines the purposes for which and
          the manner in which any personal information is processed. Any third
          parties that act as our service providers are “data processors” that
          handle your personal information in accordance with our instructions.
        </p>
        <p>
          You may object to our processing at any time and as permitted by
          applicable law if we process your personal information on the legal
          basis of consent, contract or legitimate interests. We can continue to
          process your personal information if it is necessary for the defense
          of legal claims, or for any other exceptions permitted by applicable
          law.
        </p>
        <p>
          If we process your personal information based on a contract with you
          or based on your consent, or the processing is carried out by
          automated means, you may request to receive your personal information
          in a structured, commonly used and machine-readable format, and to
          have us transfer your personal information directly to another
          “controller”, where technically feasible, unless exercise of this
          right adversely affects the rights and freedoms of others.
        </p>
        <p>
          If you believe we have infringed or violated your privacy rights,
          please contact us so that we can work to resolve your concerns. You
          also have a right to lodge a complaint with a competent supervisory
          authority situated in a Member State of your habitual residence, place
          of work, or place of alleged infringement.
        </p>

        <div className="g-maring-top"></div>
        <h5>Changes to this Statement</h5>
        <p>
          ScriptSite reserves the right to change this Privacy Policy from time
          to time. We will notify you about significant changes in the way we
          treat personal information by sending a notice to the primary email
          address specified in your account, by placing a prominent notice on
          our site, and/or by updating any privacy information on this page.
          Your continued use of the Site and/or Services available through this
          Site after such modifications will constitute your: (a) acknowledgment
          of the modified Privacy Policy; and (b) agreement to abide and be
          bound by that Policy.{" "}
        </p>

        <div className="g-maring-top"></div>
        <h5>Contact Information</h5>
        <p>
          ScriptSite welcomes your questions or comments regarding this
          Statement of Privacy. If you believe that ScriptSite has not adhered
          to this Statement, please contact ScriptSite at:{" "}
        </p>
        <div className="g-maring-top"></div>
        <p>ScriptSite Pharmacy Partners, LLC </p>
        <p>870 Market Street, Suite 1028 </p>
        <p>San Francisco, California 94102 </p>
        <p>Telephone number: (415) 800-8060 </p>
        <br/>
        <p>Effective as of September 10, 2018 </p>

        <div className="g-maring-top"></div>
        <h2>SMS Terms &amp; Conditions</h2>

        <div className="g-maring-top"></div>
        <h5>1. SMS Consent &amp; Privacy</h5>
        <p>
          The phone numbers and SMS consent information collected through our
          opt-in process will not be shared with third parties for their own
          marketing purposes.
        </p>

        <div className="g-maring-top"></div>
        <h5>2. Types of SMS Communications</h5>
        <p>
          If you consent to receive SMS messages from ScriptSite, you may
          receive messages related to follow-ups, billing or account
          inquiries, and customer service communications.
        </p>

        <div className="g-maring-top"></div>
        <h5>3. Message Frequency</h5>
        <p>
          Message frequency may vary. You may receive up to five (5) SMS
          messages per week regarding appointments, billing, account updates,
          etc.
        </p>

        <div className="g-maring-top"></div>
        <h5>4. Message &amp; Data Rates</h5>
        <p>
          Message and data rates may apply depending on your mobile carrier
          and plan.
        </p>

        <div className="g-maring-top"></div>
        <h5>5. Opt-In Method</h5>
        <p>
          You may opt in to receive SMS messages by submitting our online form
          and selecting the SMS consent checkbox.
        </p>

        <div className="g-maring-top"></div>
        <h5>6. Opt-Out Method</h5>
        <p>
          You may opt out at any time by replying STOP to any SMS message. You
          may also contact us directly to request removal from our messaging
          list.
        </p>

        <div className="g-maring-top"></div>
        <h5>7. Help</h5>
        <p>
          For assistance, reply HELP or contact us at{" "}
          <a href="tel:4158008060">415-800-8060</a> or{" "}
          <a href="mailto:hello@scriptsiterx.com">hello@scriptsiterx.com</a>.
        </p>

        <div className="g-maring-top"></div>
        <h5>8. Standard Disclosure</h5>
        <p>
          Message and data rates may apply. Message frequency may vary. Reply
          STOP to opt out or HELP for assistance. SMS consent is optional and
          is not required to purchase goods or services.
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
